import { ReactElement } from 'react'
import { DetailEditorPropsByYear } from '../types'
import { EventDetailEditor } from './EventDetailEditor'
import { EventComponentProps } from './EventDetailTypes'

interface EventDetailEditorSimplePropsByYear extends Omit<DetailEditorPropsByYear, 'name'> {
  name: string
  translationContext:
    | 'fertilizer'
    | 'amendment'
    | 'eventIrrigation'
    | 'tillage'
    | 'grazing'
    | 'liming'
    | 'naturalDisturbance'
  EventComponent: (props: EventComponentProps) => ReactElement
  defaultEvent: Record<any, any>
  modal?: boolean
  isImmutable: boolean
}

export const EventDetailEditorSimple = <
  I extends { events?: Record<any, any>[] | never[] } | undefined
>(
  props: Omit<EventDetailEditorSimplePropsByYear, 'isImmutable'>
) => <EventDetailEditor<I> {...props} simple />
